/**
 * Helpers for Working with the Navigator Share API
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
 *
 * Navigator.share() Invokes the native sharing mechanism of the current platform.
 *
 * @packageDocumentation
 */

import { logger } from 'utils/system/logger'

export interface IShareData {
    text?: string
    title?: string
    url?: string
}

export const nativeAPIShare = async (
    shareOptions: IShareData
): Promise<boolean> => {
    const anyNavigator: Navigator = window.navigator
    // check if share is available
    if (anyNavigator && anyNavigator.share) {
        return await anyNavigator
            .share(shareOptions)
            .then(() => {
                return true
            })
            .catch((err: Error) => {
                // occurs when cancelling the selected share
                logger('warn', 'Native Sharing failed:', err)
                return true
            })
    } else {
        return false
    }
}
